import Axios from 'axios'
import { Dispatch } from 'redux'

import { ActionResponse, Id } from 'util/types/index'
import { Contact, ContactData, ContactTypes } from './types'
import { clearAlert, createAlert, handleError } from 'util/modules/Alert/redux/actions'

export function createContact (personId: Id, data: ContactData) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Contact>> => {
    return Axios
      .post(`/person/${personId}/contact`, data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: ContactTypes.CONTACT_CREATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao cadastrar o contato')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function updateContact (personId: Id, id: Id, data: ContactData) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Contact>> => {
    return Axios
      .put(`/person/${personId}/contact/${id}`, data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: ContactTypes.CONTACT_UPDATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao atualizar o contato')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function deleteContact (personId: Id, id: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Contact>> => {
    return Axios
      .delete(`/person/${personId}/contact/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: ContactTypes.CONTACT_DELETE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao remover o contato')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function getContact (personId: Id, id: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Contact>> => {
    return Axios
      .get(`/person/${personId}/contact/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: ContactTypes.CONTACT_GET, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao buscar o contato')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function getContactList (personId: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Contact[]>> => {
    return Axios
      .get(`/person/${personId}/contact`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: ContactTypes.CONTACT_GET_LIST, payload: res.data })
        }
        return res
      })
  }
}
